'use es6';

import I18n from 'I18n';
import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getHasBufferedChanges } from 'ContentEditorUI/redux/selectors/editingInfoSelectors';
import { getIsScheduled } from 'ContentEditorUI/redux/selectors/publishSelectors';
import { getIsUngatedForCMPPublishing } from '../redux/selectors/authSelectors';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
const mapStateToProps = state => ({
  hasBufferedChanges: getHasBufferedChanges(state),
  isScheduled: getIsScheduled(state),
  isUngatedForCMPPublishing: getIsUngatedForCMPPublishing(state)
});

// TODO: delete this file with the removal of `ContentHub:PagesAndBlogCMPManagementAndPublishing` gate
class ShowScheduledBlogPostHasUnpublishedChanges extends Component {
  render() {
    const {
      isScheduled,
      hasBufferedChanges,
      isUngatedForCMPPublishing
    } = this.props;
    if (!isUngatedForCMPPublishing && isScheduled && hasBufferedChanges) {
      FloatingAlertStore.addAlert({
        titleText: I18n.text('scheduledPostError'),
        type: 'warning',
        timeout: 7000,
        'data-selenium': 'scheduled-blog-post-has-unpublished-changes-warning'
      });
    }
    return null;
  }
}
ShowScheduledBlogPostHasUnpublishedChanges.propTypes = {
  hasBufferedChanges: PropTypes.bool.isRequired,
  isScheduled: PropTypes.bool.isRequired,
  isUngatedForCMPPublishing: PropTypes.bool.isRequired
};
export default connect(mapStateToProps)(ShowScheduledBlogPostHasUnpublishedChanges);